<template>
  <dd-card>
    <dd-form-grid>
      <dd-form-grid-item>
        <dd-radio-group
          title="Pakket type"
          name="package_type"
          data-dusk="package-type"
          groupName="package_type"
          :render-inline="true"
          v-model="view_group_id"
        >
          <dd-radio :value="78">Pakket</dd-radio>
          <dd-radio :value="79">Servicecontract</dd-radio>
        </dd-radio-group>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-input
            data-dusk="contract-number"
            title="Pakket nummer"
            v-model="contractNumber"></dd-input>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-select
           :searchable="true"
           title="Maatschappij"
           data-dusk="corporation-id"
           v-model="corporation_id">
          <a-select-option :value="id" v-for="(agencyName, id) of agencies" :key="id">
            {{ agencyName }}
          </a-select-option>
        </dd-select>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-date-picker
            data-dusk="start-date"
            title="Ingangsdatum" v-model="startDate"
                        @input="() => {syncStartDurationEnd(form, 'startDate', 'duration', 'contractExpirationDate', 'duration');syncStartDurationEnd(form, 'startDate', 'payment_term', 'expirationDate', 'duration');}"
        ></dd-date-picker>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-input
            data-dusk="duration"
            title="Contractsduur in maanden" v-model="duration" @input="syncStartDurationEnd(form, 'startDate', 'duration', 'contractExpirationDate', 'end')"></dd-input>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-input
            data-dusk="payment-term"
            type="number" title="Betaaltermijn in maanden" v-model="payment_term" @input="syncStartDurationEnd(form, 'startDate', 'payment_term','expirationDate','end')"></dd-input>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-date-picker
            data-dusk="expiration-date"
            title="Premie vervaldatum" v-model="expirationDate" @input="syncStartDurationEnd(form, 'startDate', 'payment_term','expirationDate','duration')"></dd-date-picker>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-date-picker
            data-dusk="contract-expiration-date"
            title="Contract vervaldatum" v-model="contractExpirationDate" @input="syncStartDurationEnd(form, 'startDate', 'duration', 'contractExpirationDate', 'duration')"></dd-date-picker>
      </dd-form-grid-item>
      <dd-form-grid-item v-if="mutationCodeOptions">
        <dd-select
            :searchable="true"
            name="mutation_code"
            title="Mutatiecode"
            data-dusk="mutation-code"
            v-model="mutation_code"
            :options="mutationCodeOptions"></dd-select>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-date-picker data-dusk="mutation-date" title="Mutatiedatum" v-model="mutation_date"></dd-date-picker>
      </dd-form-grid-item>
      <dd-form-grid-item v-if="isEditing">
        <dd-textarea data-dusk="mutation-reason" title="Mutatie reden" v-model="mutation_reason"></dd-textarea>
      </dd-form-grid-item>
      <dd-form-grid-item >
        <dd-textarea data-dusk="dyn1"  v-model="dyn1" title="Omschrijving pakket" ></dd-textarea>
      </dd-form-grid-item>
    </dd-form-grid>
  </dd-card>
</template>

<script>
import {mapGetters} from "vuex";
import {mapFields} from 'vuex-map-fields';
import syncStartDurationEnd from "~/mixins/syncStartDurationEnd";

export default {
  name: "Details.vue",
  computed: {
    ...mapGetters(`$_generic_insurance`, {
      agencies: 'agencies',
      packages: 'packages',
      mutationCodeOptions: 'mutationCodeOptions',
      isEditing: 'isEditing',
    }),
    ...mapFields(`$_generic_insurance`, [
      "form.contractNumber",
      "form.corporation_id",
      "form.startDate",
      "form.duration",
      "form.payment_term",
      "form.expirationDate",
      "form.contractExpirationDate",
      "form.mutation_code",
      "form.mutation_reason",
      "form.dyn1",
      "form.mutation_date",
      "form.view_group_id",
      "form"
    ]),
  },
  mixins:[
      syncStartDurationEnd
  ]
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
